<template>
  <nav class="navbar">
    <div class="nav-container">
      <div class="nav-left">
        <router-link to="/" class="logo-link">
          <img :src="logoImage" alt="Acqtion – Acquisition Consultants" class="logo-img" />
        </router-link>
      </div>

      <div class="nav-center">
        <ul class="nav-menu" :class="{ active: mobileMenuOpen }">
          <li class="nav-item">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/fusies-en-overnames" class="nav-link">Fusies &amp; Overnames</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/financieel-advies" class="nav-link">Financieel Advies</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/cfo-as-a-service" class="nav-link">CFO as a Service</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/over-ons" class="nav-link">Over ons</router-link>
          </li>
        </ul>
      </div>

      <div class="nav-right">
        <router-link to="/contact" class="nav-link nav-cta">Contact</router-link>
        <button
          class="mobile-menu-toggle"
          @click="toggleMobileMenu"
          aria-label="Toggle menu"
          :class="{ active: mobileMenuOpen }"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import logoImage from '@/assets/logo.png'

export default {
  name: 'Navigation',
  data() {
    return {
      logoImage,
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    }
  },
  watch: {
    $route() {
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 5px;
  z-index: 1000;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 100px;
  margin-left: 20px;
  margin-right: 20px;
  border: 1px solid #e0e0e0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem max(1.5rem, calc((100% - 1200px) / 2));
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'DM Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.nav-left {
  display: flex;
  align-items: center;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  height: 40px;
  width: auto;
  display: block;
}

.nav-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  padding: 0;
}

.mobile-menu-toggle span {
  width: 18px;
  height: 2px;
  background-color: #2a2f35;
  margin: 2px 0;
  border-radius: 999px;
  transition: transform 0.25s ease, opacity 0.2s ease;
}

.mobile-menu-toggle.active span:nth-child(1) {
  transform: translateY(4px) rotate(45deg);
}

.mobile-menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active span:nth-child(3) {
  transform: translateY(-4px) rotate(-45deg);
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  display: flex;
  align-items: center;
}

.nav-link {
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-decoration: none;
  color: #6b6b7b;
  padding: 0.35rem 0;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #2a2f35;
}

.nav-cta {
  padding: 0.5rem 1.4rem;
  border-radius: 999px;
  background: #2a2f35;
  color: #ffffff !important;
  box-shadow: 0 6px 18px rgba(42, 47, 53, 0.25);
}

.nav-cta:hover {
  background: #7B9B31;
}

@media (max-width: 900px) {
  .nav-container {
    padding: 0.5rem 1.25rem;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .nav-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    flex-direction: column;
    align-items: flex-start;
    padding: 0.75rem 1.25rem;
    gap: 0.25rem;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    transition: max-height 0.25s ease-out, opacity 0.2s ease-out;
  }

  .nav-menu.active {
    max-height: fit-content;
    opacity: 1;
    pointer-events: auto;
  }

  .nav-item {
    width: 100%;
  }

  .nav-link {
    display: block;
    width: 100%;
    padding: 0.6rem 0;
    font-size: 0.95rem;
  }

  .nav-cta {
    background: transparent;
    color: #2a2f35 !important;
    border-radius: 0;
    padding: 0.6rem 0;
    width: 100%;
    text-align: center;
    box-shadow: none;
  }
}
</style>
